// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608250334/js/" + chunkId + "." + {"44":"631c76f3","225":"d6747e1a","481":"fe6c87cd","486":"2b9d9637","770":"1a027db7"}[chunkId] + ".0.9594668956128325.chunk.js";
};